import React from 'react';

import { Button } from '@qality/common-components/src/atoms/Button';
import { DetailsRow } from '@qality/common-components/src/atoms/DetailsRow';
import { Flex } from '@qality/common-components/src/atoms/Flex';
import { TextExecutionDetails } from '@qality/common-components/src/molecules/TextExecutionDetails';

import {
  PreviousTestExecutionsStyled,
  PreviousTestExecutionsTableTabsStyled,
  PreviousTestExecutionsTablesStyled,
} from './PreviousTestExecutions.styled';
import { PreviousTestExecutionsHeader } from './PreviousTestExecutionsHeader';

type Props = {
  title: string;
  onClickTab: (tabName: string) => void;
  currentTab: string;
  children: React.ReactNode;
};

export const PreviousTestExecutionsView = ({
  title,
  onClickTab,
  currentTab,
  children,
}: Props): JSX.Element => {
  return (
    <PreviousTestExecutionsStyled>
      <PreviousTestExecutionsHeader
        title={title}
        testExecutionDetails={<TextExecutionDetails />}
      />
      <PreviousTestExecutionsTableTabsStyled>
        <DetailsRow>
          <Flex alignCenter>
            <DetailsRow.Label>Show:</DetailsRow.Label>
            <DetailsRow.Value>
              <Button
                onClick={onClickTab?.bind(this, 'reported-bugs')}
                spacing='compact'
                isSelected={currentTab === 'reported-bugs'}
                marginSize='small'
                ml
              >
                Bugs reported
              </Button>
              <Button
                onClick={onClickTab?.bind(this, 'failed-steps')}
                isSelected={currentTab === 'failed-steps'}
                spacing='compact'
                marginSize='small'
                ml
              >
                Failed steps
              </Button>
            </DetailsRow.Value>
          </Flex>
        </DetailsRow>
      </PreviousTestExecutionsTableTabsStyled>
      <PreviousTestExecutionsTablesStyled>
        {children}
      </PreviousTestExecutionsTablesStyled>
    </PreviousTestExecutionsStyled>
  );
};
